/**
 * DateRangePresetSelect
 *
 * MUI TextField select that shows relative date-range options for scheduled
 * HazardAI panel reports. Used inside SubscriptionReportItemUpsert when the
 * user picks the HAZARD_AI_PANEL_REPORT type.
 */

import {MenuItem, TextField} from '@mui/material';

import {DATE_RANGE_PRESETS, DateRangePreset} from '../../utils/dateRange';

interface DateRangePresetSelectProps {
  value: DateRangePreset | null;
  onChange: (value: DateRangePreset) => void;
  fullWidth?: boolean;
}

export const DateRangePresetSelect: React.FC<DateRangePresetSelectProps> = ({
  value,
  onChange,
  fullWidth = true,
}) => {
  return (
    <TextField
      select
      fullWidth={fullWidth}
      label="Date Range"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value as DateRangePreset)}
      helperText="The report will cover this window each time it runs."
    >
      {DATE_RANGE_PRESETS.map((preset) => (
        <MenuItem key={preset.value} value={preset.value}>
          {preset.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
